import gql from "graphql-tag";

const createTypeWorkLeave = gql`
  mutation(
    $code: String!
    $title: String!
    $description: String
    $limit: Float
    $benefit: String!
    $addAttendanceSheet: Boolean
    $allowReplaceLeaveOnHoliday: Boolean
    $orderNumber: Int
  ) {
    createTypeWorkLeave(
      data: {
        code: $code
        title: $title
        description: $description
        limit: $limit
        benefit: $benefit
        addAttendanceSheet: $addAttendanceSheet
        allowReplaceLeaveOnHoliday: $allowReplaceLeaveOnHoliday
        orderNumber: $orderNumber
      }
    ) {
      id
      code
      title
      description
      limit
      benefit
      orderNumber
      createdAt
      updatedAt
      allowReplaceLeaveOnHoliday
      author {
        id
        username
        fullname
      }
    }
  }
`;

const updateTypeWorkLeave = gql`
  mutation(
    $id: ID!
    $code: String!
    $title: String!
    $description: String
    $limit: Float
    $benefit: String!
    $addAttendanceSheet: Boolean
    $allowReplaceLeaveOnHoliday: Boolean
    $orderNumber: Int
  ) {
    updateTypeWorkLeave(
      id: $id
      data: {
        code: $code
        title: $title
        description: $description
        limit: $limit
        benefit: $benefit
        addAttendanceSheet: $addAttendanceSheet
        allowReplaceLeaveOnHoliday: $allowReplaceLeaveOnHoliday
        orderNumber: $orderNumber
      }
    ) {
      id
      code
      title
      description
      orderNumber
      limit
      benefit
      updatedAt
      allowReplaceLeaveOnHoliday
    }
  }
`;

const deleteTypeWorkLeave = gql`
  mutation($id: ID!) {
    deleteTypeWorkLeave(id: $id) {
      id
    }
  }
`;

const getAllTypeWorkLeave = gql`
  query($limit: Int, $page: Int, $query: String, $benefit: String) {
    getAllTypeWorkLeave(
      query: $query
      paging: { limit: $limit, page: $page }
      filter: { benefit: $benefit }
    ) {
      id
      code
      title
      limit
      orderNumber
      benefit
      createdAt
      updatedAt
      allowReplaceLeaveOnHoliday
    }
  }
`;

const getTypeWorkLeave = gql`
  query($id: ID!) {
    getTypeWorkLeave(id: $id) {
      id
      code
      title
      limit
      benefit
      createdAt
      updatedAt
      orderNumber
      allowReplaceLeaveOnHoliday
      author {
        id
        username
        fullname
      }
      description
      addAttendanceSheet
    }
  }
`;

export default {
  createTypeWorkLeave,
  updateTypeWorkLeave,
  deleteTypeWorkLeave,
  getAllTypeWorkLeave,
  getTypeWorkLeave,
};
